import UnemployedDrillDownTable from './UnemployedDrillDownTable';

export default UnemployedDrillDownTable;
